import React from "react";
import BtnAlevel from "../../buttons/BtnALevel";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import TblALevel from "../../table/TblALevel";
import ErrorResponse from "../../components/ErrorResponse";
import PageTitle from "../../components/PageTitle";

const ALevel = () => {
  const { isLoading, error, data } = useQuery({
    queryKey: ["aLevelResult"],
    queryFn: async () => {
      const req = await axiosget("ms_applicant_alevel");
      return req?.data;
    },
  });
  return (
    <>
      <PageTitle title={`A-Level Result`} sub={`Create & delete a-level result(s)`} />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {data && <TblALevel data={data} />}
          {error && <ErrorResponse type={`danger`} message={`Error: ${error}`} />}
        </>
      )}
      <BtnAlevel />
    </>
  );
};

export default ALevel;
